import script from "./NewsAreaScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewsAreaScroll.vue?vue&type=script&setup=true&lang=ts"

import "./NewsAreaScroll.vue?vue&type=style&index=0&id=01229fd2&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01229fd2"]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton,QScrollArea,QSeparator});
